import React from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/Products.css';
import { FaChevronRight } from 'react-icons/fa';

import product1 from '../assets/product1.png';
import product2 from '../assets/product2.png';
import product3 from '../assets/product3.png';
import product4 from '../assets/product4.png';
import product5 from '../assets/product5.png';
import product6 from '../assets/product6.png';

const Products = () => {
  return (
    <div className="products-page">
      <Header />

      {/* Hero Banner Section */}
      <section className="hero-banner">
        <div className="hero-content">
          <h1>Explore Our Products</h1>
          <p>Innovative solutions for a smarter future.</p>
          <div className="breadcrumb">
            <span><a href="/">Home</a></span> <FaChevronRight /> <span>Products</span>
          </div>
        </div>
      </section>

      <section className="product-section-wrapper">
        <div className="product-grid">
          <div className="product-category-card">
            <img src={product1} alt="Position Sensors" />
            <br/>
            <h3>Position Sensors</h3>
            <br/>
            <ul>
              <li><a href='/products/InductiveSensor'>Inductive Sensors</a></li>
              <li><a href='/products/PhotoelectricSensors'>Photoelectric Sensors</a></li>
              <li><a href='/products/CapacitiveSensor'>Capacitive Sensors</a></li>
              <li><a href='/products/MagneticSensor'>Magnetic Sensors</a></li>
              <li><a href='/products/UltrasonicSensor'>Ultrasonic Sensors</a></li>
              <li><a href='/products/ColorMarkDetection'>Color Mark Detection</a></li>
            </ul>
          </div>

          <div className="product-category-card">
            <img src={product2} alt="Process Sensors" />
            <br/>
            <h3>Process / Fluid Sensors</h3>
            <br/>
            <ul>
              <li><a href='/products/PressureVacuumSensor'>Pressure / Vacuum Sensors</a></li>
              <li><a href='/products/LevelSensor'>Level Sensors</a></li>
              <li><a href='/products/FlowSensorsFlowMeters'>Flow Sensors / Flow Meters</a></li>
              <li><a href='/products/TemperatureSensors'>Temperature Sensors</a></li>
              <li><a href='/products/AnalyticalSensors'>Analytical Sensors</a></li>
              <li><a href='/products/BTU_HEAT_Meter'>BTU/HEAT Meter</a></li>
            </ul>
          </div>

          <div className="product-category-card">
            <img src={product3} alt="AI Sensors" />
            <br/>
            <h3>AI Image Recognition</h3>
            <br/>
            <ul>
              <li><a href='/products/VisionSensor'>Vision Sensor</a></li>
            </ul>
          </div>

          <div className="product-category-card">
            <img src={product4} alt="Code Reader" />
            <br/>
            <h3>Code Reader</h3>
            <br/>
            <ul>
              <li><a href='/products/CodeReader'>Code Reader</a></li>
            </ul>
          </div>

          <div className="product-category-card">
            <img src={product5} alt="Safety Sensors" />
            <br/>
            <h3>Safety Sensors</h3>
            <br/>
            <ul>
              <li><a href='/products/AreaObstacleAvoidanceSensor'>Area Obstacle Avoidance Sensor</a></li>
            </ul>
          </div>

          <div className="product-category-card">
            <img src={product6} alt="Communication And Connection" />
            <br/>
            <h3>Communication & Connection</h3>
            <br/>
            <ul>
              <li><a href='/products/NetworkAndConnection'>Network & Connection</a></li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Products;